module.exports = __webpack_public_path__ + "static/media/product-hunt-logo.095815b2.svg";